// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__T6YkB","info":"PatientInfo_info__WhRGI"};